import {List} from 'immutable';
import React from 'react';

import {Box} from '@famly/mf_layout_box';
import Tabs from 'web-app/react/components/tabs/tabs';
import {hasValue} from '@famly/stat_ts-utils_has-value';

type SummaryTabType = 'plan-overview' | 'invoice-summary';
type SummaryTab = {
    id: SummaryTabType;
    title: string;
    selected: boolean;
};

type Props = {
    children: (selectedTab: SummaryTabType) => React.ReactNode;
    // This prop is only used for testing purposes
    // TODO: Remove once the flag is removed
    isPlanOverviewEnabled?: boolean;
};

const Overview = ({children, isPlanOverviewEnabled}: Props) => {
    const [selectedTab, setSelectedTab] = React.useState<SummaryTabType>('invoice-summary');
    const summaryTabs = List<SummaryTab>(
        [
            {id: 'invoice-summary', title: 'Invoice', selected: selectedTab === 'invoice-summary'} as SummaryTab,
            isPlanOverviewEnabled
                ? ({id: 'plan-overview', title: 'Plans', selected: selectedTab === 'plan-overview'} as SummaryTab)
                : null,
        ].filter(hasValue),
    );
    return (
        <>
            <Box>
                <Tabs tabs={summaryTabs} onTabClicked={tabId => setSelectedTab(tabId as SummaryTabType)} />
            </Box>
            <Box overflow="auto">{children(selectedTab)}</Box>
        </>
    );
};

export {Overview};
